import { api, setConfig, EMAIL_SUCCESS_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const resetEmail = (data: PropertyType): Promise<string | void> =>
	api.post('/forgot', mapEntityToApi(data), setConfig(data)).then(() => {
		return EMAIL_SUCCESS_MESSAGE;
	});
